import { CircularProgress, IconButton } from "@mui/material";
import Flx from "../../../components/layout/Flx";
import TitledCard from "../../../components/ui/TitledCard";
import { ChevronRightOutlined } from "@mui/icons-material";

const DashboardWidgetCard = ({
  showLoader,
  title,
  icon,
  children,
  cardSx,
  bodyHeight,
  headerEndContent,
  headerSx,
  // bodyHeight = "185px",
  bodySx = {},
}) => {
  return (
    <TitledCard
      title={title}
      variant="h3"
      icon={icon}
      headerEndContent={headerEndContent}
      // headerContent={
      //   <IconButton>
      //     <ChevronRightOutlined />
      //   </IconButton>
      // }
      headerSx={{ pb: 2, ...headerSx }}
      cardSx={cardSx}
      bodySx={{
        pb: 0,
        position: "relative",
        // minHeight: bodyHeight,
        maxHeight: bodyHeight,
        overflowY: "auto",
        ...bodySx,
        // borderTop: "1px solid rgba(224, 224, 224, 0.9)",
      }}
      spl
      spr
      spt
      spb
    >
      {showLoader ? (
        <Flx
          fw
          center
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
          }}
        >
          <CircularProgress />
        </Flx>
      ) : (
        children
      )}
    </TitledCard>
  );
};
export default DashboardWidgetCard;
